export const DAYS_OF_WEEK = [
  "Saturday",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export const LOADING_DELAY_TIMEOUT: number = 600;

export const API_URL = import.meta.env.VITE_API_URL;

export const STRIPE_API_PUB_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
